import React from "react";
import NotHomePageNavBar from "./NotHomePageNavBar";
import Footer from "./Footer";
import "./ResumeStyle.css";
import pdfIcon from "../assets/pdfIcon.png";
import atsResume from "../assets/atsResume.pdf";

const Resume = () => (
  <div>
  <NotHomePageNavBar />
    <div>
    <div className="picture">
    <img src={pdfIcon} alt="" />
    <a href={atsResume} download>Download Printable Resume</a>
  
   
  
    <div>
 
  </div>
  </div>
      <div className="personalInfo">  
      <div>
        <h1>Jennifer Detmering</h1>
        <h4>Spanaway, WA 98387</h4>
        <h4>360-325-1819 | petal.tech@solutions.com</h4>
        <h4>LinkedIn: https://www.linkedin.com/in/jenni-detmering-86723b1bb | GitHub: https://github.com/kodiakshuksan | Portfolio: https://detmeringportfolio.netlify.app</h4>
      </div>
      </div>
      </div>
      
      <div class="summary">
        <div>
          <h1>Summary</h1>
          <h4>
          Full Stack Web Developer with a background in Psychology and life-long dedication to learning. 
          Effective at combining creativity and problem solving to develop user-friendly applications. 
          Known among staff for strong wit and attention to detail no matter the complexity of the project.   
          </h4>
        </div>
      </div>
        
      
      <div className="technicalSkills">
        <div>
          <h1 style={{textAlign: "center"}}>Technical Skills</h1>
          <h4>Languages: HTML5, CSS3, Javascript, JQuery, Bootstrap, Firebase, NodeJS, MySQL, MongoDB, Express, 
          Handelbars.js, ReactJS, Adobe, JQuery, npm, </h4>
          
        </div>
      </div>
    

      <section className="projects">
        <div>
          <h1 style={{textAlign: "center"}}>Projects</h1>
          <h3 className="myMiniGallery" style={{textAlign: "center"}}>My-Mini-Gallery</h3>
          <h4>Link to GitHub: https://github.com/kodiakshuksan/My-Mini-Gallery | Link to Deployed Project https://my-mini-gallery.herokuapp.com</h4>
            <ul className="dotText">
              <li style={{textAlign: "none"}}> This repository is for a web application that allows users to discover, view, and share artwork with each other online.
              The is for artists to use this website to build up a portfolio, and then be able to communicate with other creative minds, 
              get feedback, and build a fan-base.
              </li>
              <li style={{textAlign: "none"}}>Used npm package react-photo-gallery to build Gallery component, collaborated with team remotely using zoom, used Git workflow to plan, design, write, 
              and deploy prototype application. 
              </li>
              <li style={{textAlign: "none"}}>Technologies Used: HTML 5, CSS, Node.js, React.JS, Javascript, npm, express, MongoDB, Bootstrap, AWS
              </li>
            </ul>

            <h3 className="Meal" style={{textAlign: "center"}}>Meal Planner</h3>
            <h4>Link to GitHub: https://github.com/kodiakshuksan/MealPlanner | Link to Deployed Project: https://kodiakshuksan.github.io/MealPlanner/</h4>
              <ul className="dotText">
                <li>Plan all your meals a week ahead and save your recipes in your own personal cookbook! Not only can you 
                 you search and save recipes, but add a random cocktail also on those special nights!</li>
                <li>Implemented Luxon time/date library, researched possible free databases to use, created presentation using Adobe, presented application</li>
                <li>Worked collaboratively with my team using Agile development techniques and Scrum development processes</li>
                <li>Technologies Used: HTML 5, CSS, Javascript, Adobe</li>
              </ul>

            <h3 className="OdiApp" style={{textAlign: "center"}}>Odi-App </h3>
            <h4>Link to GitHub: https://github.com/kodiakshuksan/OdiApp | Link to Deployed Project https://kodiakshuksan.github.io/OdiApp</h4>
              <ul className="dotText">
                <li style={{textAlign: "none"}}>Converts your dog's age in human years into dog years.</li>
                <li style={{textAlign: "none"}}>Worked directly with customer to generate a software solution which included architecture and design development, source 
                code, unit test, deployment.</li>
                <li>Can assist in all phases of the software development lifecycle</li>
                <li>Able to analyze user/business needs and functionality to plan and design software systems to meet these needs.</li>
                <li>Can perform software updates, refinement, testing, and debugging</li>
                <li style={{textAlign: "none"}}>Technologies Used: HTML 5, CSS, Javascript, Adobe, Jest</li>
              </ul>
        </div>
      </section>

      <section >
        <div className="experience">
          
          <h1 style={{textAlign: "center"}}>Experience</h1>
        
            <h4>Owner                                                                                                                                        2020-Present</h4>
            <h4>Petal Tech Solutions</h4>
            <h4>Spanaway/Bellingham, WA</h4>
          
        
            <h5 style={{textAlign: "none"}}>Responsibilities: Create custom applications, provide logo/graphic design services</h5>
            <h5>Key Accomplishments:</h5>
              <ul style={{textAlign: "none"}}>
                <li className="dotText" style={{textAlign: "none"}}>Completed 1 custom application for a customer from start to finnish</li>
              </ul>
          
            <br>
            </br>

          
            <h4>Owner                                                                                                                                       2018-Present </h4>
            <h4>Garden House Gifts and Produce</h4>
            <h4>Spanaway, WA</h4>
          
            
            <h5>Responsibilities: Maintain housing project, garden and gift shop, interact with tenants and customers who support the Garden House.</h5>
            <h5 style={{textAlign: "none"}}>Key Accomplishments:</h5>
              <ul style={{textAlign: "none"}}>
                <li className="dotText" style={{textAlign: "none"}}>Providing affordable housing for 1 person for 3 years and adding housing for 1 more person in the Fall 2021!</li>
                <li className="dotText" style={{textAlign: "none"}}>Produced and Sold 150lbs. of produce and flowers to local community</li>
                <li className="dotText" style={{textAlign: "none"}}>Saved 755lbs. of trash from the landfill by repurposing and then reselling to raise money to support Garden House Gifts
                  and Produce.
                </li>
                  <li className="dotText" style={{textAlign: "none"}}>Provide part-time employment to one women in recovery for 1 year</li>
                 </ul>  
      

        
          
            <div className="education">

            <h1 style={{textAlign: "center"}}>Education</h1>
              <ul>
              <li className="dotText">Full Stack Web Development Certificate, University of Washington, Seattle, Wa</li>
                <h8 className="dotText">(A 24-week intensive  program focused on gaining technical programming skills in HTML5, CSS, Javascript, JQuery, Bootstrap,
                  Firebase, Node JS, MySQL, MongoDB, Express, HandlebarsJS and ReactJS.)
                </h8>
                <li className="dotText">Master's Degree Psychology, American School of Psychology                     Seattle, WA</li>
                <li className="dotText">Certified Nursing Assistant, School of Nursing                                Tacoma, WA</li>
                <li className="dotText">Bachelor's Degree, University of Washington                                   Tacoma, WA</li>
              </ul>
            </div>
          </div>
        </section>
  
    
    
<Footer />
</div>
);

export default Resume;
